import React from 'react';
import { Button, Spin } from 'antd';
import { checkIfLotClosed } from './LotUtil';
import './SubscribeButton.css';

/**
 * Component for subscribing to bidding notifications for a lot
 * @param {Object} props
 * @param {Object} props.selectedLot - The currently selected lot
 * @param {boolean} props.isInvitationLoading - Whether invitation status is loading
 * @param {Object} props.auction - The auction object
 * @param {boolean} props.isInvited - Whether the user is invited to the auction
 * @param {string} props.invitationStatus - Status of the invitation ('accepted', 'pending', etc.)
 * @param {Object} props.currentUser - Current logged in user
 * @param {Function} props.onSubscribe - Callback function when subscribe button is clicked
 */
const SubscribeButton = ({ 
    selectedLot, 
    isInvitationLoading, 
    auction, 
    isInvited, 
    invitationStatus, 
    currentUser, 
    onSubscribe 
}) => {
    const renderStartBiddingButton = () => (
        <Button
            type="primary"
            danger
            block
            onClick={onSubscribe}
            className="subscribe-bidding-btn"
        >
            Start Bidding
        </Button>
    );

    if (isInvitationLoading) {
        return (
            <div style={{ textAlign: 'center' }}>
                <Spin size="small" /> Loading...
            </div>
        );
    }

    if (auction?.is_private) {
        if (isInvited && invitationStatus === 'accepted' && 
            currentUser?.id !== auction?.user_id && 
            selectedLot.status === 'active' && 
            !checkIfLotClosed(selectedLot)) {
            return renderStartBiddingButton();
        }
    } else if (currentUser?.id !== auction?.user_id && 
        selectedLot.status === 'active' && 
        !checkIfLotClosed(selectedLot)) {
        return renderStartBiddingButton();
    }

    return null;
};

export default SubscribeButton;
